module.exports = __webpack_public_path__ + "img/Zepto Express.071162cd.png";